import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=407b1d2e&scoped=true"
import script from "./organization.vue?vue&type=script&lang=js"
export * from "./organization.vue?vue&type=script&lang=js"
import style0 from "./organization.vue?vue&type=style&index=0&id=407b1d2e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407b1d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407b1d2e')) {
      api.createRecord('407b1d2e', component.options)
    } else {
      api.reload('407b1d2e', component.options)
    }
    module.hot.accept("./organization.vue?vue&type=template&id=407b1d2e&scoped=true", function () {
      api.rerender('407b1d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/organization.vue"
export default component.exports